const NextStepSkeleton: React.FC = () => {
  return (
    <div className="flex-auto w-full lg:w-1/3">
        <div className="w-full space-y-3">
        <div className="animate-pulse">
            <div className="h-12 bg-gray-200 rounded w-full" />
        </div>
        <div className="animate-pulse">
            <div className="h-12 bg-gray-200 rounded w-full" />
        </div>
        </div>
    </div>
  );
};

export default NextStepSkeleton;
